import { Controller } from "@hotwired/stimulus"

// Swaps the fixed navbar between its default dark theme and a light theme
// depending on whether a light section (.dobra-light) currently sits directly
// beneath it. Keeps the nav text legible over both dark and cream backgrounds.
export default class extends Controller {
  private observer?: IntersectionObserver
  private lightSections = new Set<Element>()
  private onResize = () => this.build()

  connect() {
    this.build()
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.onResize)
  }

  // (Re)create the observer with a 1px-tall detection band just under the navbar.
  private build() {
    this.observer?.disconnect()
    this.lightSections.clear()

    const navHeight = this.element.getBoundingClientRect().height
    const bottom = Math.max(window.innerHeight - navHeight - 1, 0)

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.lightSections.add(entry.target)
          else this.lightSections.delete(entry.target)
        })
        this.element.classList.toggle("is-light", this.lightSections.size > 0)
      },
      { rootMargin: `-${navHeight}px 0px -${bottom}px 0px`, threshold: 0 }
    )

    document.querySelectorAll(".dobra-light").forEach((el) => this.observer!.observe(el))
  }
}
